import { flag1, flag2, flag3, flag4 } from "../../assets/images";

const FlagsIcons = () => {
  return (
    <div className="flex justify-center items-center gap-3">
      <img src={flag2} alt="" className="w-16" />
      <img src={flag3} alt="" className="w-16" />
      <img src={flag4} alt="" className="w-12 mx-2" />
      <img src={flag1} alt="" className="w-[70px]" />
    </div>
  );
};

export default FlagsIcons;
